import axios from "axios";

let API;

if (process.env.NODE_ENV === 'development') {
  API = axios.create({ baseURL: process.env.REACT_APP_SERVER_NAME_DEV });
} else {
  API = axios.create({ baseURL: process.env.REACT_APP_SERVER_NAME });
}

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem("profile")).token
      }`;
  }
  return req;
});

export const fetchCourses = (page) => API.get(`/courses?page=${page}`);
export const fetchCourseByName = (name) =>
  API.get(`/courses/search?name=${name}`);
export const fetchCourseById = (id) => API.get(`/courses/${id}`);
export const likeCourse = (id, anonymousId) => API.patch(`/courses/${id}/likeCourse`, { anonymousId });
export const commentCourse = (id, commentData) => API.post(`/courses/${id}/commentCourse`, commentData);
export const getCourseComments = (id) => API.get(`/courses/${id}/comments`);
export const deleteComment = (courseId, commentId) => API.delete(`/courses/${courseId}/comments/${commentId}`, { data: { commentId } });
export const getCourseRounds = (courseId) => API.get(`/courses/${courseId}/rounds`);
export const uploadCoursePicture = (id, imageData) => API.post(`/courses/${id}/pictures`, imageData);
export const getCoursePictures = (id) => API.get(`/courses/${id}/pictures`);
export const deleteCoursePicture = (courseId, picId) => API.delete(`/courses/${courseId}/pictures/${picId}`);
export const fetchMostLikedCourses = () => API.get(`/courses/mostLiked`);
export const fetchCoursesNearby = (lat, lng) => API.get(`/courses/nearby?lat=${lat}&lng=${lng}`);
export const fetchStateRankings = (state) => API.get(`/courses/rankings/${state}`);
export const fetchTopSlopeCourses = () => API.get(`/courses/top-slope`);
export const fetchTopRatedCourses = () => API.get(`/courses/top-rated`);
export const fetchEasiestCourses = () => API.get(`/courses/easiest`);
export const rateCourse = (id, value) => API.patch(`/courses/${id}/rateCourse`, { value });
export const addCourse = (course) => API.post('/courses/add', course);
export const updateCourse = (course) => API.post('/courses/update', course);
export const fetchUpdatedCourses = () => API.get('/courses/update/pending');
export const submitCourseUpdate = (course) => API.patch('/courses/update', course);
export const rejectCourseUpdate = (id) => API.delete(`/courses/update/${id}`);

export const contactMe = (contact) => API.post('/contact/me', contact)

export const fetchPosts = (page) => API.get(`/posts?page=${page}`);
export const fetchPost = (id) => API.get(`/posts/${id}`);
export const fetchPostsBySearch = (searchQuery) =>
  API.get(
    `/posts/search?searchQuery=${searchQuery.searchTerm || "none"}&tags=${searchQuery.tags
    }`
  );
export const createPost = (newPost) => API.post("/posts", newPost);
export const updatePost = (id, updatedPost) =>
  API.patch(`/posts/${id}`, updatedPost);
export const deletePost = (id) => API.delete(`/posts/${id}`);
export const likePost = (id) => API.patch(`/posts/${id}/likePost`);
export const comment = (value, id) =>
  API.post(`/posts/${id}/commentPost`, { value });

export const signin = (formData) => API.post("/user/signin", formData);
export const signup = (formData) => API.post("/user/signup", formData);
export const deleteAccount = () => API.delete("/users/delete");
export const getUserProfile = (userId) => API.get(`/users/${userId}`);
export const updateUserProfile = (userData) => API.patch("/users/profile", userData);
export const logRound = (userId, roundData) => API.post(`/users/${userId}/rounds`, roundData);
export const getUserRounds = (userId) => API.get(`/users/${userId}/rounds`);
export const deleteRound = (userId, roundId) => API.delete(`/users/${userId}/rounds/${roundId}`);
